export default __webpack_public_path__ + "static/media/most3.000f4a9c.jpg";